// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__13_zw","rootCenter":"LoadMoreObserver_rootCenter__3AQH_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3nWDU"};